/**
 * PathwayCanvasZoomControls (Sprint 4.3.5).
 *
 * Thin wrapper around React Flow's built-in <Controls> that pins zoom
 * +/- + fit-to-view buttons to the lower-left below the minimap, per
 * the Awell Studio canvas reference. Must be rendered as a child of
 * <ReactFlow>.
 *
 * HC2 token-only. The visual chrome of <Controls> is themed via the
 * React-Flow CSS bundled at the top of `PathwayCanvas.tsx`.
 */
import { Controls } from 'reactflow';

export function PathwayCanvasZoomControls() {
  return (
    <Controls
      data-testid="pathway-canvas-zoom-controls"
      position="bottom-left"
      showInteractive={false}
    />
  );
}
